import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const StyledDatePicker = styled(DatePicker, {
})(({ theme }) => ({
  "& label": {
    color: theme.palette["black_solid"]["70"],
    left: "-6px",
    fontSize: theme.typography["body1"]["fontSize"],
    marginTop: "-5px"
  },
  "& legend": {
    marginLeft: "-3px"
  },
  "& label.Mui-focused": {
    color: theme.palette["primary"]["60"],
  },
  "& label.Mui-error": {
    color: theme.palette["error"]["60"]
  },
  "& label.Mui-disabled": {
    color: theme.palette["black_opacity"]["40"]
  },
  "& .MuiInputLabel-shrink": {
    marginTop: "0px"
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette["black_opacity"]["30"],
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette["primary"]["60"],
    },
    "&.Mui-error fieldset": {
      borderColor: theme.palette["error"]["60"],
    },
    "&.Mui-disabled fieldset": {
      backgroundColor: theme.palette["black_opacity"]["05"],
      borderColor: theme.palette["black_opacity"]["30"],
    }
  },
  "& .MuiInputBase-input": {
    fontSize: theme.typography["body1"]["fontSize"],
    fontWeight: "body1.fontWeight",
    backgroundColor: theme.palette["white_opacity"]["100"],
    color: theme.palette["black_opacity"]["100"],
    padding: "4px 8px",
    "&.Mui-disabled": {
      WebkitTextFillColor: theme.palette["black_opacity"]["40"]
    }
  },
  "& .MuiButtonBase-root": {
    color: theme.palette["black_opacity"]["70"],
    padding: "0px",
    "&.Mui-disabled": {
      color: theme.palette["black_opacity"]["40"],
    },
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  "& .MuiSvgIcon-root": {
    height: "20px",
    width: "20px",
    padding: "0 6px 0 0"
  }
}));

export default StyledDatePicker;